export default {
    attribute:{
        size:'medium',layout:'horizontal',autoSwitch: false, timeout:5, trigger:'next'
    },
    interaction:{multi:true},
    cptDataForm:{
        dataText: '{"value":"next","options":[{"label":"上一页","value":"prev"},{"label":"首页","value":"current"},{"label":"下一页","value":"next"}]}',
        apiUrl:'/select', sql:'select id from test limit 1',
        dataSource: 1, pollTime: -1
    }
}